<script>
  import { get, call } from 'vuex-pathify'

  export default {
    computed: {
      ...get('account', ['loggedIn']),
    },
    watch: {
      loggedIn() {
        if (!this.loggedIn) {
          this.$navigate({ name: 'AccountLogin' })
        }
      },
    },
    created() {
      this.logoutAndRedirect()
      this.$cookies.remove('visitedDashboard', null, '.alltrue.com')
    },
    methods: {
      ...call('account', ['logout']),
      logoutAndRedirect() {
        this.logout().then(() => {
          this.$navigate({ name: 'AccountLogin' })
        })
      },
    },
  }
</script>

<template>
  <section class="w-full h-full">
    <BaseSpinner v-if="loggedIn" overlay="fixed" overlay-color="white" class="z-90" />
  </section>
</template>
